import React from "react";
import {
  Typography,
  Container,
  Link,
  Box,
  Divider,
  CssBaseline,
  Paper,
  useTheme,
} from "@mui/material";

export default function GrievancePolicy() {
  const theme = useTheme(); // use theme

  return (
    <>
      <CssBaseline />

      <Container maxWidth="lg" sx={{ mt: 9, mb: 4 }}>
        <Paper
          elevation={3}
          sx={{
            p: { xs: 3, md: 4 },
            backgroundColor: theme.palette.background.paper,
          }}
        >
          {/* Title */}
          <Typography
            variant="h4"
            gutterBottom
            sx={{
              fontSize: { xs: "16px", md: "18px" },
              fontWeight: 700
            }}
            color={theme.palette.primary.main} // theme primary
          >
            Grievance Redressal Policy
          </Typography>

          <Divider sx={{ my: 2 }} />

          <Typography variant="body2" sx={{ mb: 3 }} color={theme.palette.text.primary}>
            If you have any grievances, complaints, questions, comments, or
            concerns regarding the processing of your information, this Privacy
            Policy, or any other privacy or security-related matters concerning
            the App or Website, please feel free to reach out to us.
          </Typography>

          <Box mb={3}>
            {/* General privacy or security concerns */}
            <Box mb={3}>
              <Typography
                variant="h8"
                fontWeight="bold"
                gutterBottom
                color={theme.palette.text.primary}
              >
                For general privacy or security concerns:
              </Typography>

              <Typography variant="body2" sx={{ mb: 0.5 }} color={theme.palette.text.primary}>
                Chief Grievance Officer: Priyaranjan Thakur
              </Typography>
              <Typography variant="body2" color={theme.palette.text.primary}>
                Email us at:{" "}
                <Link href="mailto:support@arthgyan.com" color="primary">
                  support@arthgyan.com
                </Link>
              </Typography>
            </Box>

            {/* ArthGyan services issues */}
            <Box mb={3}>
              <Typography
                variant="h8"
                fontWeight="bold"
                gutterBottom
                color={theme.palette.text.primary}
              >
                For issues specifically related to ArthGyan services:
              </Typography>
              <Typography variant="body2" sx={{ mb: 0.5 }} color={theme.palette.text.primary}>
                You may contact our Grievance Redressal Officer at{" "}
                <Link href="mailto:support@arthgyan.com" color="primary">
                  support@arthgyan.com
                </Link>
                . We are committed to addressing your concerns within 30 days
                from the date of receipt.
              </Typography>
              <Typography variant="body2" color={theme.palette.text.primary}>
                Phone number:{" "}
                <Link href="tel:9595027710" color="primary">
                  9595027710
                </Link>
              </Typography>
            </Box>

            {/* Credit bureau related grievances */}
            <Box mb={3}>
              <Typography
                variant="h8"
                fontWeight="bold"
                gutterBottom
                color={theme.palette.text.primary}
              >
                For credit report-related grievances (e.g., CRIF, Experian):
              </Typography>
              <Typography variant="body2" sx={{ mb: 1 }} color={theme.palette.text.primary}>
                Please contact the respective credit bureau's grievance
                redressal officer. You can find their contact details on their
                official websites or credit information support pages. Resolution
                will be provided within the timelines specified by the respective
                bureaus.
              </Typography>

              <Typography variant="body2" color={theme.palette.text.primary}>
                We value your feedback and are committed to resolving your concerns
                promptly and fairly.
              </Typography>
            </Box>
          </Box>
        </Paper>
      </Container>
    </>
  );
}
